module.exports = __webpack_public_path__ + "static/media/refresh-button.1198ed41.svg";